import useEntity from "../../hooks/usePricingProfile";
import PricingProfileDetail from "../../components/pricingProfile/PricingProfileDetail/PricingProfileDetail";
import PricingProfileScoped from "../../components/pricingProfile/PricingProfileDetail/PricingProfileScoped";
import PricingProfileTabs from "../../components/pricingProfile/PricingProfileDetail/PricingProfileTabs";
import { useGetPricingProfileQuery } from "../../apis/PricingProfile.api";
import { PrimaryPricingProfile } from "../../types/models/PricingProfile";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const PricingProfileDetailPage = () => {

    useTitle(t`Details Pricing Profile`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { pricingProfileId: id } = useParams();

    const { data, refetch } = useGetPricingProfileQuery(PrimaryPricingProfile.fromPath(id))
    const { deletePricingProfile } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deletePricingProfile(data, '..')
    }, [data, deletePricingProfile])

    if (id === 'scoped') {
        return (<PricingProfileScoped/>)
    }

    return (
        <Box data-testid="PricingProfile-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <PricingProfileDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em"}}>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/PricingProfiles/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="PricingProfile-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/PricingProfiles/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="PricingProfile-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <PricingProfileTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default PricingProfileDetailPage;
